// eslint-disable-next-line
// @ts-nocheck
import { itemType } from 'metadata';

const getRelshipItem = (stateData, state) => {
	const { selectedId } = state;
	return stateData.get(selectedId);
};

const getRelatedItem = (stateData, state) => {
	const { related_id: relatedId } = getRelshipItem(stateData, state);
	return stateData.get(relatedId);
};

const getAccessValue = (stateData, state) => {
	const relshipItem = getRelshipItem(stateData, state);
	const { 'role@aras.keyed_name': label } = relshipItem;
	return { label };
};

const getMultiLingualValue = (stateData, state, property) => {
	const { languages } = state;
	const relatedItem = getRelatedItem(stateData, state);
	return languages.reduce((result, { code }) => {
		result[code] = relatedItem[`${property}@aras.lang.${code}`];
		return result;
	}, {});
};

const getImageValue = (stateData, state) => {
	const { image } = getRelatedItem(stateData, state);
	return image;
};

const getItemTypeValue = (stateData, state) => {
	const relatedItem = getRelatedItem(stateData, state);
	const { additional_data: additionalData } = relatedItem;
	const { itemTypeId } = additionalData;
	const label = itemType.getItemTypeName(itemTypeId);
	return { label };
};

const getFormValue = (stateData, state) => {
	const relatedItem = getRelatedItem(stateData, state);
	const { additional_data: additionalData } = relatedItem;
	const { formId } = additionalData;
	const label = aras.getKeyedName(formId, 'Form');
	return { label };
};

const getSortValue = (stateData, state) => {
	const { selectedSortingType } = state;
	return selectedSortingType;
};

const getPageValue = (stateData, state, property) => {
	const relatedItem = getRelatedItem(stateData, state);
	const { additional_data: additionalData } = relatedItem;
	return additionalData[property] ?? '';
};

const getItemValue = (stateData, state) => {
	const relatedItem = getRelatedItem(stateData, state);
	const { additional_data: additionalData } = relatedItem;
	const { itemId, itemTypeId } = additionalData;
	const itemTypeName = itemType.getItemTypeName(itemTypeId);
	const label = aras.getKeyedName(itemId, itemTypeName);
	return { label };
};

const propertyValueGenerators = {
	access: getAccessValue,
	label: (...args) => getMultiLingualValue(...args, 'label'),
	image: getImageValue,
	itemType: getItemTypeValue,
	startPage: getPageValue,
	parameters: getPageValue,
	form: getFormValue,
	sort: getSortValue,
	item: getItemValue
};

export const getFormValues = (stateData, state, order) => {
	return order.reduce((result, property) => {
		const value = propertyValueGenerators[property](stateData, state, property);
		result[property] = value;
		return result;
	}, {});
};
